import React, { Component } from 'react';
import ReactLoadingTop from "../../components/ReactErrorTop";

class VatCard extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    return <div style={{border: 'solid 3px #dce2e7', borderRadius: '20px', width: '100%', paddingLeft: '8px', position: 'relative', height: '90px'}}>
      <div style={{fontSize: '20px', fontWeight: '800'}}>
        {this.props.title}
      </div>
      <div style={{fontSize: '16px', fontWeight: '500'}}>
        {this.props.body}
      </div>
      {this.props.loading && <ReactLoadingTop style={{width:"15px", height: "15px"}} />}
    </div>
  }
}

export default VatCard;
